export function getCodeFromUrl() {
  return new URL(window.location.href).searchParams.get("code");
}
